<template>
  <div class="lp-container">
    <b-overlay
      class="lp-container"
      :show="loading"
      variant="transparent"
      rounded="sm"
    >
      <div class="lps-successful">
        <div class="successful_title">
          {{ $t('Payment Successful') }}
        </div>
        <img
          v-if="!showAuth || user"
          src="../../assets/images/lps/payment-successful.png"
          class="1-100"
          alt="successful"
        >
        <h3 :class="showAuth && !user ? 'mt-1' : 'mt-3'">
          {{ $t('Welcome to Boho!') }}
        </h3>
        <p class="mt-05 text-center">
          {{ $t('Now you can chat and video chat as you wish. Don\'t forget to download our application..') }}
        </p>
        <div
          v-if="showAuth && !user"
          class="lp-content mt-2"
        >
          <lp-auth
            :loading="loading"
            :send-main-page-after-auth="true"
            :show-auth="true"
            @setLoading="loading = $event"
          />
        </div>
        <div
          v-else
          class="d-flex justify-content-center flex-column"
        >
          <a
            class="mt-2"
            href="https://play.google.com/store/apps/details?id=com.arasana.arasana"
          >
            <img
              src="../../assets/images/lps/google-play.png"
              class="1-100"
              alt="Google Play"
            >
          </a>
          <a
            class="mt-1"
            href="https://apps.apple.com/app/boho-live-video-chat-talk-meet/id1264652539"
          >
            <img
              src="../../assets/images/lps/app-store.png"
              class="1-100"
              alt="App Store"
            >
          </a>
          <p class="text-center mt-1">
            {{ $t('Or') }}
          </p>
          <div class="text-center">
            {{ $t('Continue with') }} <br>
            <router-link
              :to="{name: 'index'}"
              class="color-pink"
            >
              {{ $t('Boho website') }}
            </router-link>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import LpAuth from '@/components/Lp/LpAuth.vue'
import moment from 'moment'
import { BOverlay } from 'bootstrap-vue'

export default {
  name: 'PaymentSuccessful',
  components: {
    BOverlay,
    LpAuth,
  },
  data() {
    return {
      loading: false,
      showAuth: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },
  created() {
    const showAuth = localStorage.getItem('show_auth') || null
    const showAuthTime = localStorage.getItem('show_auth_time') || null

    // eslint-disable-next-line radix
    if (showAuth && showAuth === 'true' && showAuthTime && moment(parseInt(showAuthTime)).isAfter(moment().unix())) {
      this.showAuth = true
    }
  },
}
</script>

<style scoped lang="scss">
.lps-successful {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 12px;

  .successful_title {
    background-color: #D3F2DC;
    border: 2px solid #95E0AA;
    padding: 12px;
    text-align: center;
    width: 100%;
    color: #00E380 !important;
    border-radius: 12px;
    font-size: 22px;
    margin-bottom: 12px;
  }
}
</style>
